import React from 'react';
import "./OverviewCardsSection.scss";
import arrow from "../../Assets/image (68).png";
import img1 from "../../Assets/image (69).png";
import img2 from "../../Assets/image (67).png";
import img3 from "../../Assets/image (70).png";
import img4 from "../../Assets/image (70).png"; 

export default function OverviewCardsSection() {
  const cardsData = [
    {
      id: 1,
      title: "75",
      subtitle: "Total Orders",
      percent: "25% (30 days)",
      image: img1
    },
    {
      id: 2,
      title: "120",
      subtitle: "New Clients",
      percent: "15% (30 days)",
      image: img2
    },
    {
      id: 3,
      title: "320",
      subtitle: "Products Sold",
      percent: "35% (30 days)",
      image: img3
    },
    {
      id: 4,
      title: "8,450 EGP",
      subtitle: "Total Revenue",
      percent: "12% (30 days)",
      image: img4
    }
  ];

  return (
    <div className='bg-cards'>
      {cardsData.map(card => (
        <div className='card' key={card.id}>
          <img src={card.image} height={80} width={80} alt="card" />
          <div>
            <h3>{card.title}</h3>
            <p>{card.subtitle}</p>
            <div className='right-part'>
              <img src={arrow} width={20} alt="arrow" />
              <span>{card.percent}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
